import gql from 'graphql-tag';
import { DEAL_BUILDER_QUOTE_FRAGMENT } from './dealBuilderQuote.fragment';

export const DEAL_BUILDER_ENTITY_FRAGMENT = gql`
  fragment DealBuilderEntityFields on DealBuilder {
    proposalId
    proposal {
      createdDateTime
      businessName
      firstName
      lastName
      saleType
      amountRequested
      status
      salesPersonName
      vendorOpportunityId
      proposalId
      category
      acceptedPaymentCriteriaSnapshot
      settings {
        configuration {
          formData
          builder
          pricing
          productsConfig
          commonProductsConfiguration
        }
      }
    }
    proposalContacts {
      proposalContactsId
      proposalId
      ownerPgId
      accountContactId
    }
    proposalEquipments {
      proposalEquipmentsId
      proposalId
      equipmentId
    }
    quote {
      ...DealBuilderQuoteFields
    }
  }
  ${DEAL_BUILDER_QUOTE_FRAGMENT}
`;
